import { render, staticRenderFns } from "./OnboardingToolbar.vue?vue&type=template&id=45dcffae"
import script from "./OnboardingToolbar.vue?vue&type=script&lang=js"
export * from "./OnboardingToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports